export default "__VITE_ASSET__c676f229__"